import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routeOptions = [
    {
        path: '/',
        name: 'Home',
    },
    {
        path: '/products/:id',
        name: 'Products',
    },
    {
        path: '/about',
        name: 'About',
    },
    {
        path: '/contact',
        name: 'Contact',
    },
    {
        path: '/stores',
        name: 'Stores',
    },
]

const routes = routeOptions.map(route => {
    return {
        ...route,
        component: () => import(/* webpackChunkName: "[request]" */`@/views/${route.name}.vue`),
    }
})

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
})

export default router
